var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgHashtag(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16.049,
    height: 15.79,
    viewBox: "0 0 16.049 15.79",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "hashtag",
    d: "M15.081,11.514H13.126l.683-2.988a1.023,1.023,0,0,0-.7-1.214,1,1,0,0,0-1.256.751l-.788,3.45H6.537L7.22,8.526a1.023,1.023,0,0,0-.7-1.214,1,1,0,0,0-1.256.751l-.788,3.45H2.214a.984.984,0,0,0,0,1.967H4.022l-.771,3.373H.968a.984.984,0,0,0,0,1.967H2.8l-.683,2.988a1.023,1.023,0,0,0,.7,1.214,1,1,0,0,0,1.256-.752l.788-3.45H9.391l-.683,2.988a1.023,1.023,0,0,0,.7,1.214,1,1,0,0,0,1.256-.752l.788-3.45H13.7a.984.984,0,0,0,0-1.967H11.906l.771-3.373h2.4a.984.984,0,0,0,0-1.967Zm-5.24,5.34H5.316l.771-3.373h4.524Z",
    transform: "translate(0 -7.273)",
    fill: "#656565"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHashtag);
export default __webpack_public_path__ + "static/media/hashtag.a074dabe80d63cee369b7e8a4dd908e8.svg";
export { ForwardRef as ReactComponent };